/* Top Racing Point - selettore auto (Marca / Modello / Versione).
   Usato sulle collezioni-gruppo e sulle collezioni principali elencate in snippets/trp-gruppi-bar.liquid.
   Legge titolo e tag dei prodotti della collezione (/collections/<handle>?view=trpauto&page=N):
   - Marca    = tag uguale alla marca (es. "honda")
   - Modello  = il tag "marca modello" che compare nel titolo subito dopo "per <Marca>" (es. "honda civic")
   - Versione = gli altri tag della stessa marca su quel prodotto (telai: "honda eg", "honda ek"...)
   Tag sporchi gestiti senza modificarli: "alfa romeo romeo 155" vale come Alfa Romeo 155,
   "mercedes benz" / "ford usa" / "volkswagen audi" valgono come tag della sola marca.
   Tag doppi dello stesso modello ("fiat seicento" e "fiat seicento/600", "mazda mx-5" e "mazda mx5")
   diventano una sola voce, filtrata con il tag piu usato del gruppo: i prodotti con l'altra scrittura
   devono avere anche quel tag (sistemato sui prodotti il 2026-10-11).
   Terza tendina (Versione): compare solo se il modello ha tag di versione (telai, es. Civic EG / EK).
   Il filtro usa sempre i tag reali: /collections/<handle>/<tag-modello>+<tag-versione> (AND, senza app).
   Modo "multi" (data-trp-auto-modo="multi", es. Mozzi Volante, 2026-10-17): legge SOLO i tag dedicati
   "trpmv:<marca>", "trpmv:<marca>:<modello>" e (dal 2026-10-20) "trpmv:<marca>:<modello>:<versione>";
   un prodotto puo valere per piu marche, modelli e versioni.
   Nomi da mostrare e ordine delle versioni: window.TRPAutoNomi (assets/trp-auto-nomi.js),
   chiavi "marca|modello" e "marca|modello|versione" -> [nome, ordine]. Senza voce si usa il nome dal tag. */
(function(){
  var MARCHE=['abarth','alfa romeo','alpine','aston martin','audi','austin','bentley','bmw','cadillac','chevrolet','chrysler','citroen','cupra','dacia','daewoo','daihatsu','datsun','dodge','ferrari','fiat','ford','honda','hummer','hyundai','infiniti','isuzu','jaguar','jeep','kia','lada','lamborghini','lancia','land rover','lexus','lotus','maserati','mazda','mclaren','mercedes','mercedes-benz','mg','mini','mitsubishi','nissan','opel','peugeot','pontiac','porsche','renault','rover','saab','seat','skoda','smart','ssangyong','subaru','suzuki','tesla','toyota','triumph','vauxhall','volkswagen','volvo'];
  var SIGLE={bmw:'BMW',mg:'MG',vw:'VW',ds:'DS',tvr:'TVR',gmc:'GMC'};
  // sotto-tag che in realta indicano solo la marca (tag sporchi)
  var SOLO_MARCA={'mercedes':['benz'],'ford':['usa'],'volkswagen':['audi','vw']};
  var MIN_PRODOTTI=3;   // sotto questo numero di prodotti con auto, il selettore non compare
  var PARALLELE=6;      // pagine di dati scaricate insieme
  MARCHE.sort(function(a,b){ return b.length-a.length; });

  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function sortText(a,b){ return a.localeCompare(b,'it',{numeric:true,sensitivity:'base'}); }
  function option(v,l){ var o=document.createElement('option'); o.value=v; o.textContent=l; return o; }
  function senzaAccenti(t){ return String(t).normalize('NFD').split('').filter(function(ch){ var k=ch.charCodeAt(0); return k<768 || k>879; }).join(''); }
  function handleize(t){ return senzaAccenti(String(t).toLowerCase()).replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function norm(t){ return senzaAccenti(String(t).toLowerCase()).replace(/[^a-z0-9]+/g,' ').trim(); }
  function parola(w){
    if(SIGLE[w]) return SIGLE[w];
    if(/\d/.test(w) || w.length<=3 || /^(ttrs|vtec|wrx)$/.test(w)) return w.toUpperCase();
    return w.charAt(0).toUpperCase()+w.slice(1);
  }
  function etichetta(t){ if(/^[a-z]{3,}( [a-z]{3,})+$/.test(t)) return t.split(' ').map(function(w){ return w.charAt(0).toUpperCase()+w.slice(1); }).join(' '); return t.split(' ').map(function(w){ return w.indexOf('-')>-1 ? w.split('-').map(parola).join('-') : parola(w); }).join(' '); }
  function etichettaMarca(m){ return SIGLE[m] || m.split(' ').map(function(w){ return w.split('-').map(function(x){ return x.charAt(0).toUpperCase()+x.slice(1); }).join('-'); }).join(' '); }
  // chiave per riconoscere lo stesso modello scritto in modi diversi: "mx-5"="mx5", "seicento/600"="seicento", "megane" con accento = "megane"
  function canon(s){ return norm(String(s).split('/')[0]).replace(/ /g,''); }
  function sembraTelaio(s){ return s.length<=3 || (s.length<=5 && /\d/.test(s) && !/-/.test(s)); }

  // Pulisce il sotto-tag: '' = tag della sola marca
  function pulisci(m, sub){
    var ultima=m.split(' ').pop();
    if(sub===ultima) return '';                                        // "alfa romeo romeo"
    if(sub.indexOf(ultima+' ')===0) sub=sub.slice(ultima.length+1);    // "alfa romeo romeo 155" -> "155"
    if((SOLO_MARCA[m]||[]).indexOf(sub)>-1) return '';
    if(MARCHE.indexOf(sub)>-1) return '';                              // "volkswagen audi" ecc.
    return sub;
  }
  function preferito(attuale, nuovo, m){
    // per la marca preferisce il tag esatto ("mercedes") a quelli sporchi ("mercedes benz")
    if(!attuale) return nuovo;
    if(nuovo===m) return nuovo;
    return attuale;
  }

  // Costruisce marca -> modello -> versioni dai prodotti (conserva sempre i tag reali)
  function analizza(prodotti){
    var dati={}, conAuto=0;
    prodotti.forEach(function(p){
      var titolo=norm(p[0]), tags=(p[1]||[]).map(function(t){ return String(t).trim().toLowerCase(); });
      var perMarca={};
      tags.forEach(function(t){
        for(var i=0;i<MARCHE.length;i++){
          var m=MARCHE[i], sub='';
          if(t===m){ sub=''; }
          else if(t.indexOf(m+' ')===0){ sub=pulisci(m, t.slice(m.length+1)); }
          else continue;
          var c=(m==='mercedes-benz') ? 'mercedes' : m;
          perMarca[c]=perMarca[c]||{tagMarca:'',sub:[],reale:{}};
          if(!sub){ perMarca[c].tagMarca=preferito(perMarca[c].tagMarca,t,c); }
          else if(!perMarca[c].reale[sub]){ perMarca[c].sub.push(sub); perMarca[c].reale[sub]=t; }
          return;
        }
      });
      var trovato=false;
      Object.keys(perMarca).forEach(function(m){
        var info=perMarca[m]; trovato=true;
        dati[m]=dati[m]||{tag:'',modelli:{}};
        if(info.tagMarca) dati[m].tag=preferito(dati[m].tag,info.tagMarca,m);
        // stesso modello scritto in due modi sullo stesso prodotto: ne resta uno (preferito quello senza "/")
        var visti={}, tuttiTag={};
        info.sub.slice().sort(function(a,b){ return (a.indexOf('/')>-1)-(b.indexOf('/')>-1) || a.length-b.length; }).forEach(function(s){ var c=canon(s); if(!visti[c]) visti[c]=s; (tuttiTag[c]=tuttiTag[c]||[]).push(info.reale[s]); });
        info.sub=info.sub.filter(function(s){ return visti[canon(s)]===s; });
        if(!info.sub.length) return;
        // modello: il sotto-tag che segue "per <marca>" nel titolo (il piu lungo)
        var modello='';
        var pos=titolo.indexOf(norm(m)+' ');
        var dopo=pos>-1 ? titolo.slice(pos+norm(m).length+1) : '';
        info.sub.forEach(function(s){ var n=norm(s); if(dopo && (dopo===n || dopo.indexOf(n+' ')===0) && n.length>modello.length) modello=s; });
        if(!modello){
          var parole=info.sub.filter(function(s){ return !sembraTelaio(s); });
          modello=(parole.length ? parole : info.sub).slice().sort(function(a,b){ return b.length-a.length; })[0];
        }
        var mod=dati[m].modelli[modello]=dati[m].modelli[modello]||{tags:[info.reale[modello]],versioni:{},conta:{}};
        (tuttiTag[canon(modello)]||[info.reale[modello]]).forEach(function(t){ mod.conta[t]=(mod.conta[t]||0)+1; });
        var vers=info.sub.filter(function(s){ return s!==modello; });
        // versioni scritte di seguito nel titolo (es. "Del Sol") diventano una sola voce
        var grezzo=String(p[0]).toLowerCase(), usati={};
        vers.forEach(function(a){ vers.forEach(function(b){
          if(a!==b && /^[a-z]{3,}$/.test(a) && /^[a-z]{3,}$/.test(b) && grezzo.indexOf(a+' '+b)>-1){ mod.versioni[a+' '+b]=[info.reale[a],info.reale[b]]; usati[a]=usati[b]=true; }
        }); });
        vers.forEach(function(s){ if(!usati[s]) mod.versioni[s]=[info.reale[s]]; });
      });
      if(trovato) conAuto++;
    });
    // stesso modello scritto in modi diversi: una sola voce, filtrata con il tag presente su piu prodotti
    Object.keys(dati).forEach(function(m){
      var mods=dati[m].modelli, gruppi={};
      Object.keys(mods).forEach(function(k){ var c=canon(k); (gruppi[c]=gruppi[c]||[]).push(k); });
      Object.keys(gruppi).forEach(function(c){
        var ks=gruppi[c];
        var conta={};
        ks.forEach(function(k){ Object.keys(mods[k].conta).forEach(function(t){ conta[t]=(conta[t]||0)+mods[k].conta[t]; }); });
        var ordine=Object.keys(conta).sort(function(a,b){ return (a.indexOf('/')>-1)-(b.indexOf('/')>-1) || conta[b]-conta[a] || a.length-b.length; });
        if(ks.length<2){ mods[ks[0]].tags=[ordine[0]||mods[ks[0]].tags[0]].concat(ordine.slice(1)); return; }
        if(ordine[0].indexOf('/')>-1) return;   // solo varianti con "/" (es. "s14/r34" e "s14/s14a"): restano separate
        // la voce che resta e' quella del tag principale
        var principale=ks.filter(function(k){ return mods[k].tags[0]===ordine[0] || Object.prototype.hasOwnProperty.call(mods[k].conta,ordine[0]); })[0] || ks[0];
        var dest=mods[principale];
        ks.forEach(function(k){
          if(k===principale) return;
          var src=mods[k];
          Object.keys(src.versioni).forEach(function(v){ if(!dest.versioni[v]) dest.versioni[v]=src.versioni[v]; });
          delete mods[k];
        });
        dest.conta=conta; dest.tags=ordine;
      });
    });
    // un "modello" senza versioni che compare anche come versione di un altro modello resta solo versione
    Object.keys(dati).forEach(function(m){
      var mods=dati[m].modelli;
      Object.keys(mods).forEach(function(k){
        var anche=Object.keys(mods).some(function(k2){ return k2!==k && mods[k2].versioni[k]; });
        if(anche && !Object.keys(mods[k].versioni).length) delete mods[k];
      });
    });
    return {dati:dati, conAuto:conAuto};
  }

  // nomi dei modelli scritti a mano nel modo multi (dove la regola automatica sbaglia)
  var NOMI_MULTI={'uno':'Uno','ka':'Ka','4runner':'4Runner','coupe':'Coupe','gt':'GT'};
  // Modo multi: marca, modello e versione solo dai tag dedicati "trpmv:<marca>[:<modello>[:<versione>]]"
  function analizzaMulti(prodotti){
    var dati={}, conAuto=0;
    prodotti.forEach(function(p){
      var trovato=false;
      (p[1]||[]).forEach(function(t0){
        var t=String(t0).trim().toLowerCase();
        if(t.indexOf('trpmv:')!==0) return;
        var parti=t.slice(6).split(':'), m=parti[0], mod=parti[1]||'', ver=parti.slice(2).join(':');
        if(!m) return;
        trovato=true;
        dati[m]=dati[m]||{tag:'',modelli:{}};
        if(!mod){ dati[m].tag='trpmv:'+m; return; }
        var tm='trpmv:'+m+':'+mod;
        var x=dati[m].modelli[mod]=dati[m].modelli[mod]||{tags:[tm],versioni:{},conta:{}};
        if(ver){ x.versioni[ver]=[t]; return; }
        x.conta[t]=(x.conta[t]||0)+1;
      });
      if(trovato) conAuto++;
    });
    return {dati:dati, conAuto:conAuto};
  }

  // Scarica i dati: prima pagina, poi le altre in parallelo (PARALLELE alla volta)
  function carica(base, fatto){
    var chiave='trpauto5:'+base, cache=null;
    try{ cache=JSON.parse(sessionStorage.getItem(chiave)||'null'); }catch(e){}
    if(cache && cache.t && (Date.now()-cache.t)<3600000){ fatto(cache.p); return; }
    function pagina(n){
      return fetch(base+'?view=trpauto&page='+n,{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(txt){ return JSON.parse(txt); });
    }
    pagina(1).then(function(d1){
      var totale=Math.min(d1.pagine||1, 60), risultati=[d1.p||[]], prossima=2, attive=0, finito=false;
      function fine(){
        if(finito) return; finito=true;
        var tutti=[]; risultati.forEach(function(r){ if(r) tutti=tutti.concat(r); });
        try{ sessionStorage.setItem(chiave,JSON.stringify({t:Date.now(),p:tutti})); }catch(e){}
        fatto(tutti);
      }
      function avvia(){
        if(prossima>totale && attive===0){ fine(); return; }
        while(attive<PARALLELE && prossima<=totale){
          (function(n){
            attive++;
            pagina(n).then(function(d){ risultati[n-1]=d.p||[]; }).catch(function(){ risultati[n-1]=[]; }).then(function(){ attive--; avvia(); });
          })(prossima++);
        }
      }
      avvia();
    }).catch(function(){ fatto([]); });
  }

  if(typeof document!=='undefined') ready(function(){
    // i tag tecnici trpmv: non devono comparire tra i filtri della colonna laterale
    document.querySelectorAll('li.advanced-filter[data-handle^="trpmv-"]').forEach(function(li){ li.parentNode.removeChild(li); });
    var root=document.querySelector('[data-trp-auto-finder]'); if(!root) return;
    var base=(root.getAttribute('data-collection-url')||'').replace(/\/$/,'');
    var selMarca=root.querySelector('[data-trp-auto-make]');
    var selModello=root.querySelector('[data-trp-auto-model]');
    var selVersione=root.querySelector('[data-trp-auto-version]');
    var invia=root.querySelector('[data-trp-auto-submit]');
    var azzera=root.querySelector('[data-trp-auto-reset]');
    // nelle collezioni grandi il riquadro compare subito con "Caricamento..."
    var subito=root.hasAttribute('data-trp-auto-subito');
    var multi=root.getAttribute('data-trp-auto-modo')==='multi';
    function nomi(){ return (typeof window!=='undefined' && window.TRPAutoNomi) || {}; }
    function voce(k){ var x=nomi()[k]; return x ? (typeof x==='string' ? [x,0] : x) : null; }
    function nomeModello(marca,k){ var x=multi && voce(marca+'|'+k); return (x && x[0]) || (multi && NOMI_MULTI[k]) || etichetta(k); }
    function nomeVersione(marca,mod,v){ var x=multi && voce(marca+'|'+mod+'|'+v); return (x && x[0]) || etichetta(v); }
    function ordineVersione(marca,mod,v){ var x=multi && voce(marca+'|'+mod+'|'+v); return x ? (x[1]||0) : 0; }
    if(subito){ root.hidden=false; selMarca.innerHTML=''; selMarca.appendChild(option('','Caricamento auto...')); selMarca.disabled=true; }

    carica(base,function(prodotti){
      var r=multi ? analizzaMulti(prodotti) : analizza(prodotti), dati=r.dati;
      var marche=Object.keys(dati).filter(function(m){ return dati[m].tag || Object.keys(dati[m].modelli).length; }).sort(sortText);
      if(!marche.length || r.conAuto<MIN_PRODOTTI){ root.hidden=true; return; }
      root.hidden=false;
      selMarca.disabled=false; selMarca.innerHTML=''; selMarca.appendChild(option('','Seleziona marca'));
      marche.forEach(function(m){ selMarca.appendChild(option(m,etichettaMarca(m))); });

      function riempiModelli(marca,scelto,terzoScelto){
        selModello.innerHTML=''; selModello.appendChild(option('','Tutti i modelli'));
        selVersione.innerHTML=''; selVersione.appendChild(option('','Tutte le versioni'));
        selModello.disabled=!marca; selVersione.disabled=true; mostraVersione(false); invia.disabled=!marca;
        if(!marca) return;
        var mods=dati[marca].modelli;
        Object.keys(mods).sort(function(a,b){ return sortText(nomeModello(marca,a),nomeModello(marca,b)); }).forEach(function(k){ selModello.appendChild(option(k,nomeModello(marca,k))); });
        if(!Object.keys(mods).length) selModello.disabled=true;
        if(scelto && mods[scelto]){ selModello.value=scelto; riempiVersioni(marca,scelto,terzoScelto); }
      }
      // la casella Versione si vede solo quando il modello scelto ha delle versioni
      var campoVersione=selVersione.closest('.trp-vehicle-finder__field')||selVersione.parentNode;
      function mostraVersione(si){ if(campoVersione) campoVersione.style.display = si ? '' : 'none'; }
      mostraVersione(false);
      function riempiVersioni(marca,modello,scelta){
        selVersione.innerHTML=''; selVersione.appendChild(option('','Tutte le versioni'));
        var mod=marca && modello ? dati[marca].modelli[modello] : null;
        var vers=mod ? Object.keys(mod.versioni) : [];
        if(!vers.length){ selVersione.disabled=true; mostraVersione(false); return; }
        vers.sort(function(a,b){ return (ordineVersione(marca,modello,a)-ordineVersione(marca,modello,b)) || sortText(nomeVersione(marca,modello,a),nomeVersione(marca,modello,b)); }).forEach(function(v){ selVersione.appendChild(option(v,nomeVersione(marca,modello,v))); });
        selVersione.disabled=false; mostraVersione(true);
        if(scelta && mod.versioni[scelta]) selVersione.value=scelta;
      }
      // percorso del filtro con i tag reali (AND): marca | modello | modello+versione
      function destinazione(){
        var marca=selMarca.value, modello=selModello.value, versione=selVersione.value;
        if(!marca) return null;
        var mod=modello ? dati[marca].modelli[modello] : null;
        if(!mod) return dati[marca].tag ? [dati[marca].tag] : null;
        var path=[mod.tags[0]];
        if(versione && mod.versioni[versione]) path=multi ? mod.versioni[versione].slice() : path.concat(mod.versioni[versione]);
        return path;
      }
      function indirizzo(baseUrl,d){
        var qs=new URLSearchParams(window.location.search); qs.delete('page'); qs.delete('filter.p.tag');
        var p=d && d.length ? d.map(handleize).join('+') : '';
        var u=baseUrl.replace(/\/$/,'')+(p ? '/'+p : ''); var q=qs.toString(); return q ? u+'?'+q : u;
      }
      function aggiornaPulsante(){ invia.disabled=!destinazione(); }

      selMarca.addEventListener('change',function(){ riempiModelli(this.value,''); aggiornaPulsante(); });
      selModello.addEventListener('change',function(){ riempiVersioni(selMarca.value,this.value,''); aggiornaPulsante(); });
      selVersione.addEventListener('change',aggiornaPulsante);
      invia.addEventListener('click',function(e){
        e.preventDefault();
        var d=destinazione(); if(!d) return;
        window.location.assign(indirizzo(base,d));
      });
      azzera.addEventListener('click',function(e){ e.preventDefault(); window.location.assign(base); });

      // Ripristina la scelta leggendo l'indirizzo (/collections/<handle>/<tag>+<tag>)
      var parti=window.location.pathname.replace(/\/$/,'').split('/');
      var seg=parti.length>3 && parti[1]==='collections' ? decodeURIComponent(parti[3]) : '';
      if(seg){
        var pezzi=seg.split('+'), mSel='', modSel='', terSel='';
        marche.forEach(function(m){
          pezzi.forEach(function(x){
            if(dati[m].tag && x===handleize(dati[m].tag)) mSel=m;
            Object.keys(dati[m].modelli).forEach(function(k){
              var md=dati[m].modelli[k];
              if(md.tags.some(function(t){ return x===handleize(t); })){ mSel=m; modSel=k; }
              if(multi) Object.keys(md.versioni).forEach(function(v){ if(md.versioni[v].some(function(t){ return x===handleize(t); })){ mSel=m; modSel=k; terSel=v; } });
            });
          });
          if(!multi && mSel===m && modSel){
            var mod=dati[m].modelli[modSel], vv=mod.versioni, lung=0;
            Object.keys(vv).forEach(function(v){ if(vv[v].every(function(s){ return pezzi.indexOf(handleize(s))>-1; }) && vv[v].length>lung){ terSel=v; lung=vv[v].length; } });
          }
        });
        if(mSel){
          selMarca.value=mSel; riempiModelli(mSel,modSel,terSel);
          var p=destinazione();
          if(p){
            // i riquadri dei gruppi mantengono l'auto scelta
            document.querySelectorAll('.trp-gruppi__tile').forEach(function(a){
              var href=a.getAttribute('href'); if(!href) return;
              a.setAttribute('href',indirizzo(href.split('?')[0],p));
            });
          }
        }
      }
      aggiornaPulsante();
    });
  });

  // per i test fuori dal browser
  if(typeof module!=='undefined') module.exports={analizza:analizza, analizzaMulti:analizzaMulti, handleize:handleize, etichetta:etichetta, canon:canon, MARCHE:MARCHE, pulisci:pulisci};
})();
